<div class="wrapper">
  <div class="header flex justify-between items-start">
    <div class="left flex gap-[20px]">
      <div class="image-section">
        <mat-icon
          [svgIcon]="icon"
          class="category-icon"
          />
      </div>
      <div
        [class.justify-center]="!!subheading"
        [class.justify-start]="!subheading"
        class="details-section flex flex-col  items-start"
        >
        <div class="heading text-type-6 mb-[4px]">{{ heading }}</div>
        <div class="subheading text-type-10">{{ subheading }}
          @if (displayMatched) {
            <span class="matched ml-[10px]">
              @if (matchedOccurrences > 0) {
                {{ matchedOccurrences }} {{ matchedOccurrences > 1 ? 'occurrences' : 'occurrence' }}
              } @else {
                @if (matchedCount !== itemCount) {
                  <span>{{ matchedCount }}</span>
                }
                matched
              }
          </span>
        }
      </div>
    </div>
  </div>
  <div class="right">
    <mat-icon
      [svgIcon]="isExpanded ? 'chevron-up' : 'chevron-down'"
      class="chevron"
      />
  </div>
</div>
@if (isExpanded) {
  <div class="content">
    <ng-content />
  </div>
}
</div>
